module.exports = __webpack_public_path__ + "img/icon2_qs.83556196.png";